import TransferWizard from './components/TransferWizard';
import TransferHistory from './components/TransferHistory';

export default function TransfersPage() {
  return (
    <div data-testid="page-transfers" className="flex flex-col h-full p-4 gap-4">
      <TransferWizard />
      <TransferHistory />
    </div>
  );
}
